<template>
  <div class="container">
    <!-- 标题 -->
    <h3 class="title">农技咨询统计</h3>

    <!-- 筛选功能 -->
    <div class="filter-container">
      <div class="filter-grid">
        <div class="filter-group">
          <label class="filter-label">开始时间</label>
          <el-date-picker @change="changeStartTime" v-model="form.startTime" value-format="yyyy-MM-dd"
            placeholder="选择日期" size="small" class="full-width"></el-date-picker>
        </div>
        <div class="filter-group">
          <label class="filter-label">结束时间</label>
          <el-date-picker @change="changeEndTime" v-model="form.endTime" value-format="yyyy-MM-dd" placeholder="选择日期"
            size="small">
          </el-date-picker>
        </div>
        <div class="filter-group">
          <label class="filter-label">地区</label>
          <el-cascader ref="cascader" v-model="form.areaCode" :props="props" @change="regionChange" :options="options"
            placeholder="选择地区" clearable size="small" class="full-width"></el-cascader>
        </div>
        <div class="action-group">
          <el-button type="primary" size="small" @click="applyFilter" class="action-btn">
            <i class="el-icon-finished"></i>筛选
          </el-button>
          <el-button type="success" size="small" class="action-btn" @click="exportData">
            <i class="el-icon-bottom"></i>导出
          </el-button>
        </div>
      </div>
    </div>

    <!-- 统计信息 -->
    <div class="stats-row">
      <div class="stat-card total-count">
        <div class="label">总咨询数量</div>
        <div class="value-group">
          <strong class="col">{{totalConsultNumber}}</strong>
          <span class="icon icon-chat">
            <i class="el-icon-chat-line-round"></i>
          </span>
        </div>
      </div>
      <div class="stat-card answered-count">
        <div class="label">已解答数量</div>
        <div class="value-group">
          <strong class="col2">{{replyNumber}}</strong>
          <span class="icon icon-check">
            <i class="el-icon-circle-check"></i>
          </span>
        </div>
      </div>
      <div class="stat-card pending-count">
        <div class="label">未解答数量</div>
        <div class="value-group">
          <strong class="col3">{{notReplyNumber}}</strong>
          <span class="icon icon-warning">
            <i class="el-icon-warning-outline"></i>
          </span>
        </div>
      </div>
    </div>

    <!-- 图表区域 -->
    <div class="chart-row">
      <el-row :gutter="20">
        <el-col :span="12">
          <div class="chart-card">
            <div class="title">农技咨询各地区回复数量</div>
            <div ref="pieChart" style="height: 300px"></div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="chart-card">
            <div class="title">专家回复数量排名</div>
            <div ref="barChart" style="height: 300px"></div>
          </div>
        </el-col>
      </el-row>
    </div>

    <!-- 专家信息表格 -->
    <div class="expert-table">
      <el-table :data="expertData" style="width: 100%">
        <el-table-column label="专家信息">
          <template #default="{ row }">
            <div class="items-center">
              <div class="imgBox">
                <div class="img" :style="getImageBackgroundColor(row)">
                  <div class="font">{{row.expertName ? row.expertName.charAt(0) : ''}}</div>
                </div>
              </div>

              <div class="expert-info">
                <div class="name">{{ row.expertName }}</div>
                <div class="specialty">{{ row.field }}</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="所属地区">
          <template #default="{ row }">
            <div class="region">{{ row.areaName }}</div>
          </template>
        </el-table-column>
        <el-table-column label="累计咨询">
          <template #default="{ row }">
            <div class="count">{{ row.consultNumber }}</div>
          </template>
        </el-table-column>
        <el-table-column label="已解答">
          <template #default="{ row }">
            <el-tag size="small" type="success">{{ row.replyNumber }}</el-tag>
          </template>
        </el-table-column>

        <el-table-column label="未解答">
          <template #default="{ row }">
            <el-tag size="small" :type="getColorByValue(row.notReplyNumber)">
              {{ row.notReplyNumber }}
            </el-tag>
          </template>
        </el-table-column>

      </el-table>

      <!-- 分页 -->
      <div class="pagination">
        <span class="demonstration">Total：{{total}}</span>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="query.current" :page-size="query.size" small layout="prev, pager, next, jumper"
          :total="total"  :current-page.sync="currentPage"></el-pagination>
          
          
      </div>
    </div>
  </div>
</template>
<script>
  import * as echarts from 'echarts';
  import { mapGetters } from "vuex";
  import { AreaTree } from "@/api/RuralFinance";
  import { removeEmptyChildren } from "@/js/utils/util";
  import { selectExpertNumberByAreaCode, selectConsultArea, selectExpertNumber } from '@/api/problemConsultation'
  export default {
    data() {
      return {
        // 筛选数据
        form: {
          startTime: null,
          endTime: null,
          areaCode: '',
        },
        // 专家数据
        expertData: [],// ... 其他专家数据
        props: {
          label: "areaName",
          children: "children",
          value: "id",
          // checkStrictly: true,
          // emitPath: false,
        }, // 地区自定义函数
        options: [],//地区列表
        pieChart: null,
        barChart: null,
        colors: ['#fde7e9', '#dff6dd', '#c7e0f4'],//随机色
        notReplyNumber: 0,//未解答数量
        replyNumber: 0, // 已解答数量
        totalConsultNumber: 0, // 已解答数量
        query: {
          current: 1,
          size: 5
        },//分页
        total: 0,//总页数
        chartCard: [], // 饼状图数据
        chartCard2: [], // 柱状图数据
        currentPage:1,//前往的页数
      };
    },
    computed: {
      ...mapGetters(["identityObj"]),
    },
    // watch: {
    //   topSelectAreacode(newVal, oldVal) {
    //     console.log('topSelectAreacode 变化了:', newVal, oldVal);
    //     this.form.areaCode = newVal
    //     this.selectExpertNumber();
    //     this.selectConsultArea();
    //     this.selectExpertNumberByAreaCode();
    //   }
    // },
    mounted() {

      this.selectExpertNumber()
      this.selectConsultArea()
      this.selectExpertNumberByAreaCode()
      this.AreaTree()
      this.$nextTick(() => {
        this.initPieChart();
        this.initBarChart();
      });
    },
    methods: {
      //开始时间判断
      changeEndTime() {
        let starttime = new Date(this.form.startTime).getTime()
        let endtime = new Date(this.form.endTime).getTime()

        if (endtime < starttime) {
          this.$message.error("结束时间不能小于开始时间");
          this.form.endTime = ""; // 补贴申请结束时间
        }
      },
      // 结束时间判断
      changeStartTime() {
        if (!this.form.endTime) return
        let starttime = new Date(this.form.startTime).getTime()
        let endtime = new Date(this.form.endTime).getTime()
        if (endtime < starttime) {
          this.$message.error("开始时间不能大于结束时间");
          this.form.startTime = ""; // 补贴申请结束时间

        }
      },
      //未解答颜色的转换
      getColorByValue(value) {
        if (value === 0) {
          return 'success'; // 绿色
        } else if (value > 0 && value < 10) {
          return 'warning'; // 橙色
        } else {
          return 'danger'; // 红色
        }
      },
      // 初始化饼图
      initPieChart() {
        this.pieChart = echarts.init(this.$refs.pieChart);

        const options = {
          animation: false,
          selectedMode: false, // 禁用选中模式
          tooltip: { trigger: 'item' },
          legend: {
            top: '5%', left: 'center', itemGap: 20,
            itemWidth: 20
          },
          series: [
            {
              name: '咨询量',
              type: 'pie',
              radius: ['30%', '55%'],
              itemStyle: {
                borderRadius: 10,
                borderColor: '#fff',
                borderWidth: 2,
              },
              data: this.changeList(this.chartCard)
            },
          ],
        };
        this.pieChart.setOption(options);
      },

      // 初始化柱状图
      initBarChart() {
        this.barChart = echarts.init(this.$refs.barChart);

        const options = {
          legend: {
            selectedMode: false,
             show: false // 显式设置为不显示
          },
      
          animation: false,
          tooltip: {
            trigger: 'axis',
            axisPointer: { type: 'shadow' },
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true,
          },
          xAxis: { type: 'value', boundaryGap: [0, 0.1] },
          yAxis: {
            type: 'category',
            data: this.changeList2(this.chartCard2, "name"),
          },
           xAxis: {
     
            minInterval: 1,  // 最小刻度间隔为1
          
          },
          series: [
            {
              name: '解答数量',
              type: 'bar',
              data: this.changeList2(this.chartCard2, "replyNumber"),
              itemStyle: {
                color: function (params) {
                  const colorList = ['#4CAF50', '#8BC34A', '#CDDC39', '#FFC107', '#FF9800'];
                  return colorList[params.dataIndex];
                },
              },
            },
          ],
        };
        this.barChart.setOption(options);
      },

      //每页数据
      handleSizeChange(psize) {
        this.query.size = psize;
        this.selectExpertNumber();
      },
      // 当前页
      handleCurrentChange(current) {
        this.query.current = current;
        this.selectExpertNumber();
      },
      // 地区数据
      async AreaTree() {
        let res = await AreaTree({ parentCode: this.identityObj.areaCode, level: 4, })
        this.options = removeEmptyChildren(res.data);

      },

      //饼状图数据转化
      changeList(list) {
        return list.map(item => ({
          name: item.areaName,
          value: item.replyNumber
        }));
      },
      //柱状图数据转化
      changeList2(list, type) {
        if (type === "name") {
          return list.map(item => item.expertName);
        } else {
          return list.map(item => item.replyNumber);
        }
      },
      // 筛选功能
      applyFilter() {
        // console.log(this.form, '查看this.form');
        this.selectExpertNumber();
        this.selectConsultArea();
        this.selectExpertNumberByAreaCode();
      },
      // 导出数据功能
      exportData() {
        console.log('导出数据功能待实现');
      },
      // 随机生成背景色
      getImageBackgroundColor(row) {
        const name = row.expertName || '';
        const colorIndex = this.hashCode(name);
        const color = this.colors[colorIndex];
        return {
          backgroundColor: color,
          width: '50px',
          height: '50px',
          borderRadius: '50%',
        };
      },
      // 将名字转成哈希值的方法
      hashCode(str) {
        // DJB2哈希算法平衡计算效率和分布均匀性
        let hash = 0;
        for (let i = 0; i < str.length; i++) {
          hash = str.charCodeAt(i) + ((hash << 5) - hash);
        }
        const index = Math.abs(hash) % this.colors.length;
        return index
      },
      //地区选择
      regionChange() {
        let node = this.$refs.cascader.getCheckedNodes()[0];
        this.areaHasChild = node.hasChildren;
        this.form.areaCode = node.value;

      },

      //专家列表数据
      async selectExpertNumber() {
        let params = {
          ...this.form,
          ...this.query,
        };
        let res = await selectExpertNumber(params);
        this.expertData = res.data.records;
        this.total = Number(res.data.total);
      },
      //饼状图数据
      async selectConsultArea() {
        let params = {
          ...this.form,
        };
        // console.log(params, '查看params')
        let res = await selectConsultArea(params);
        this.chartCard = res.data;
        this.$nextTick(() => {
          this.initPieChart();
        });
      },
      // 柱状图数据
      async selectExpertNumberByAreaCode() {
        let params = {
          ...this.form,
          ...this.query,
        };
        let res = await selectExpertNumberByAreaCode(params);
        this.notReplyNumber = res.data.notReplyNumber.toLocaleString();
        this.replyNumber = res.data.replyNumber.toLocaleString();
        this.totalConsultNumber = res.data.totalConsultNumber.toLocaleString();
        this.chartCard2 = res.data.consultReplyVoList;
        this.$nextTick(() => {
          this.initBarChart();
        });
      }
    }
  };
</script>

<style scoped lang="less">
  .container {
    padding: 20px;
  }

  /* 筛选 */
  .filter-container {
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    padding: 20px;
  }

  .filter-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 20px;
    align-items: end;
  }

  .filter-group {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .filter-label {
    font-size: 14px;
    color: #333;
    line-height: 1.5;
  }

  .full-width {
    width: 100%;
  }

  .action-group {
    display: flex;
    gap: 10px;
    justify-content: space-around;
    /* align-self: center; */
  }

  .action-btn {
    flex-shrink: 0;
  }

  /* 统计信息 */
  .stats-row {
    display: flex;
    margin-top: 20px;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    justify-content: space-between;
  }

  .stat-card {
    flex: 1;
    border: 1px solid #888;
    border-radius: 4px;
    /* background:red; */
    padding: 20px;
    margin: 10px;
  }

  .total-count {
    border: 1px solid #ccc;
  }

  .answered-count {
    border: 2px solid #00c292;

    .icon-check {
      background-color: #E8F9EE;
      color: #30C868
    }

    .col2 {
      color: #00c292
    }
  }

  .pending-count {
    border: 2px solid #ff4d4f;

    .icon-warning {
      background-color: #FDECEC;
      color: #F37F7F;
    }

    .col3 {
      color: #ff4d4f;
    }
  }

  .label {
    font-size: 14px;
  }

  .value-group {
    display: flex;
    align-items: center;
    margin-top: 10px;
    justify-content: space-between;
  }

  .value-group strong {
    font-size: 24px;
    margin-right: 10px;
  }

  .icon {
    display: inline-block;
    width: 50px;
    height: 50px;
    border-radius: 50%;

    text-align: center;
    line-height: 50px;
  }

  /* 图表区域 */
  .chart-row {
    border-radius: 8px;
    margin-top: 20px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    padding: 10px;
  }

  .chart-card {
    border: 1px solid #ebebeb;
    border-radius: 4px;
    padding-top: 10px;
    height: 100%;
    box-sizing: border-box;

    .title {
      width: 98%;
      font-weight: 800;
      font-size: 20px;
      height: 30px;
      border-bottom: solid 1px #E4E7ED;
      padding-left: 2%;
    }
  }

  .el-row {
    margin-left: -10px !important;
    margin-right: -10px !important;
  }

  .el-col {
    padding-left: 10px !important;
    padding-right: 10px !important;
  }

  /* 专家信息表格 */
  .expert-table {
    margin-top: 20px;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    padding: 10px;
  }

  /* 分页 */
  .pagination {
    display: flex;
    justify-content: center;
    margin-top: 20px;

    span {
      text-align: center;
    }
  }

  .items-center {
    display: flex;

    .imgBox {
      width: 50px;
      height: auto;
      display: flex;
      align-items: center;
      /* background: red; */
           margin-right: 20px;
    }

    .img {
      width: 50px;
      height: 50px;
      background-color: black;
      border-radius: 25px;
      .font {
        width: 50px;
        height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 25px;
      }
    }
  }

  .specialty {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>